export const TPBANK_ADMIN = "TPBANK_ADMIN"

export const TPBANK_ADMIN_LOGIN = "TPBANK_ADMIN_LOGIN"